<template>
    <div v-loading="loading" class="page_container">
        <div class="page_header">
            <div>
                <span class="return_btn_wrap" @click="handleClickReturn">
                    <i class="el-icon-arrow-left"></i>
                    <span>返回</span>
                </span>
                <span class="line"></span>
                <span class="page_title">工单详情</span>
            </div>
            <div class="work_order_header_flex">
                <!-- 极简模式=审批中，:待指派，待实施，实施中，实施完成，已评价 -->
                <!-- 工程模式 =审批中，待指派，待出发，待实施，实施中，实施完成，已结单，已评价 -->
                <!-- 工单状态：0=>审批中，1=>待指派，2=>待出发，3=>待实施，4=>实施中，5=>实施完成，6=>已结单，7=>已评价,-1=>已拒绝，-2=>已撤销，-3=>已关闭 -->
                <!-- 实施人状态：0=>未出发，1=>待实施, 2=>实施中, 3=>实施完成 -->

                <!-- 因为不同状态的按钮的等级不一样，也就是按钮样式不一样，所以只能按照状态判断显示 -->
                <el-button
                    size="small"
                    type="primary"
                    v-if="workOrderDetailsData.status === 0 && workOrderDetailsData.uid === owner_uid"
                    @click="handleClickRevokeWorkOrder"
                    >撤销</el-button
                >
                <el-button
                    size="small"
                    v-if="
                        (workOrderDetailsData.status == -1 || workOrderDetailsData.status == -2) &&
                        workOrderDetailsData.uid === owner_uid
                    "
                    @click="handleClickDelWorkOrder"
                    >删除</el-button
                >
                <el-button
                    size="small"
                    type="primary"
                    v-if="
                        (workOrderDetailsData.status == -1 ||
                            workOrderDetailsData.status == -2 ||
                            workOrderDetailsData.status == -3) &&
                        workOrderDetailsData.uid === owner_uid
                    "
                    @click="handleClickRestartWorkOrder"
                    >再次发起</el-button
                >
                <template v-if="workOrderDetailsData.status == 1">
                    <!-- 待指派 -->
                    <el-button
                        size="small"
                        type="primary"
                        v-if="workOrderDetailsData.is_assign_user"
                        @click="handleClickDistributeWorkOrder"
                        >分配实施人员</el-button
                    >
                    <!-- <el-button
                        size="small"
                        type="primary"
                        plain
                        v-if="workOrderDetailsData.uid === owner_uid"
                        @click="handleClickEditWorkOrder"
                        >编辑信息</el-button
                    > -->
                    <el-button
                        size="small"
                        v-if="workOrderDetailsData.uid === owner_uid"
                        @click="handleClickCloseWorkOrder"
                        >关闭工单</el-button
                    >
                </template>
                <template
                    v-else-if="
                        workOrderDetailsData.status == 2 ||
                        workOrderDetailsData.status == 3 ||
                        workOrderDetailsData.status == 4
                    "
                >
                    <!-- 2=>待出发，3=>待实施，4=>实施中 -->
                    <el-button
                        size="small"
                        type="primary"
                        v-if="isCurrentProcessingUserStatus === 0 && workOrderDetailsData.is_processing_user"
                        @click="handleClickStartWorkOrder"
                        >出发</el-button
                    >
                    <el-button
                        size="small"
                        type="primary"
                        v-if="isCurrentProcessingUserStatus === 1 && workOrderDetailsData.is_processing_user"
                        @click="handleClickWorkOrderImplementStart"
                        >实施开始</el-button
                    >
                    <el-button
                        size="small"
                        type="primary"
                        v-if="
                            isCurrentProcessingUserStatus === 3 &&
                            workOrderDetailsData.mode === 2 &&
                            workOrderDetailsData.is_processing_user
                        "
                        @click="handleClickEndWorkOrder"
                        >结单</el-button
                    >
                    <el-button
                        size="small"
                        type="primary"
                        plain
                        v-if="
                            (workOrderDetailsData.status === 2 || workOrderDetailsData.status === 3) &&
                            workOrderDetailsData.is_has_assign_user
                        "
                        @click="handleClickDistributeWorkOrder"
                        >分配实施人员</el-button
                    >
                    <el-button
                        size="small"
                        type="primary"
                        v-if="isCurrentProcessingUserStatus === 2 && workOrderDetailsData.is_processing_user"
                        @click="handleClickWorkOrderDailyWork"
                        >每日工作填写</el-button
                    >
                    <el-button
                        size="small"
                        type="primary"
                        plain
                        v-if="isCurrentProcessingUserStatus === 2 && workOrderDetailsData.is_processing_user"
                        @click="handleClickWorkOrderImplementEnd"
                        >实施结束</el-button
                    >
                    <el-select
                        v-if="isMoreOperateBtn"
                        v-model="moreOperateType"
                        size="small"
                        placeholder="请选择"
                        style="width: 126px"
                    >
                        <el-option
                            key="transferWorkOrder"
                            label="转单"
                            value="transferWorkOrder"
                            v-if="
                                (isCurrentProcessingUserStatus === 0 || isCurrentProcessingUserStatus === 1) &&
                                workOrderSetForm &&
                                workOrderSetForm.is_transfer === 1 &&
                                workOrderDetailsData.is_processing_user
                            "
                            @click.native="handleMoreOpetateTypeChange('transferWorkOrder')"
                        ></el-option>
                        <el-option
                            key="distributeWorkOrder"
                            label="分配实施人员"
                            value="distributeWorkOrder"
                            v-if="workOrderDetailsData.status === 4 && workOrderDetailsData.is_has_assign_user"
                            @click.native="handleMoreOpetateTypeChange('distributeWorkOrder')"
                        ></el-option>
                        <el-option
                            key="replaceWorkOrder"
                            label="替换实施人员"
                            value="replaceWorkOrder"
                            v-if="
                                (workOrderDetailsData.status === 2 ||
                                    workOrderDetailsData.status === 3 ||
                                    workOrderDetailsData.status === 4) &&
                                workOrderDetailsData.is_has_assign_user
                            "
                            @click.native="handleMoreOpetateTypeChange('replaceWorkOrder')"
                        ></el-option>
                        <el-option
                            key="revokeDistributeWorkOrder"
                            label="撤回实施人员"
                            value="revokeDistributeWorkOrder"
                            v-if="
                                (workOrderDetailsData.status === 2 ||
                                    workOrderDetailsData.status === 3 ||
                                    workOrderDetailsData.status === 4) &&
                                workOrderDetailsData.is_has_assign_user
                            "
                            @click.native="handleMoreOpetateTypeChange('revokeDistributeWorkOrder')"
                        ></el-option>
                        <el-option
                            key="closeWorkOrder"
                            label="关闭工单"
                            value="closeWorkOrder"
                            v-if="
                                (workOrderDetailsData.status === 2 ||
                                    workOrderDetailsData.status === 3 ||
                                    workOrderDetailsData.status === 4) &&
                                workOrderDetailsData.uid === owner_uid
                            "
                            @click.native="handleMoreOpetateTypeChange('closeWorkOrder')"
                        ></el-option>
                    </el-select>
                </template>
                <template v-else-if="workOrderDetailsData.status == 5 || isCurrentProcessingUserStatus === 3">
                    <!-- 实施完成 -->
                    <el-button
                        size="small"
                        type="primary"
                        v-if="
                            isCurrentProcessingUserStatus === 3 &&
                            workOrderDetailsData.mode === 2 &&
                            workOrderDetailsData.is_processing_user && workOrderDetailsData.status < 6
                        "
                        @click="handleClickEndWorkOrder"
                        >结单</el-button
                    >
                    <el-button
                        size="small"
                        type="primary"
                        :plain="isCurrentProcessingUserStatus === 3"
                        v-if="workOrderDetailsData.status == 5 && workOrderDetailsData.is_has_assign_user"
                        @click="handleClickDistributeWorkOrder"
                        >分配实施人员</el-button
                    >
                    <el-button
                        size="small"
                        type="primary"
                        plain
                        v-if="
                            (workOrderDetailsData.status === 5 &&
                                workOrderSetForm.is_evaluate == 1 &&
                                workOrderDetailsData.mode === 1 &&
                                workOrderDetailsData.is_has_assign_user) ||
                            (workOrderDetailsData.status === 6 &&
                                workOrderSetForm.is_evaluate == 1 &&
                                workOrderDetailsData.mode === 2 &&
                                workOrderDetailsData.is_has_assign_user)
                        "
                        @click.native="handleClickEvaluateWorkOrder()"
                        >评价</el-button
                    >
                    <!-- <el-button
                        size="small"
                        type="primary"
                        plain
                        v-if="
                            (workOrderDetailsData.status === 1 ||
                                workOrderDetailsData.status === 2 ||
                                workOrderDetailsData.status === 3 ||
                                workOrderDetailsData.status === 4 ||
                                workOrderDetailsData.status === 5) &&
                            workOrderDetailsData.uid === owner_uid
                        "
                        @click="handleClickEditWorkOrder"
                        >编辑信息</el-button
                    > -->
                    <el-button
                        size="small"
                        v-if="
                            (workOrderDetailsData.status === 1 ||
                                workOrderDetailsData.status === 2 ||
                                workOrderDetailsData.status === 3 ||
                                workOrderDetailsData.status === 4 ||
                                workOrderDetailsData.status === 5) &&
                            workOrderDetailsData.uid === owner_uid
                        "
                        @click="handleClickCloseWorkOrder"
                        >关闭工单</el-button
                    >
                </template>
                <template v-else-if="workOrderDetailsData.status == 6">
                    <el-button
                        size="small"
                        type="primary"
                        v-if="
                            (workOrderDetailsData.status === 5 &&
                                workOrderSetForm.is_evaluate == 1 &&
                                workOrderDetailsData.mode === 1 &&
                                workOrderDetailsData.is_has_assign_user) ||
                            (workOrderDetailsData.status === 6 &&
                                workOrderSetForm.is_evaluate == 1 &&
                                workOrderDetailsData.mode === 2 &&
                                workOrderDetailsData.is_has_assign_user)
                        "
                        @click.native="handleClickEvaluateWorkOrder()"
                        >评价</el-button
                    >
                </template>
            </div>
        </div>
        <div class="page_body">
            <div class="work_order_info_wrap">
                <div class="page_little_title">
                    <span class="title">工单信息</span>
                </div>
                <div>
                    <CustomFormDetailPc
                        v-if="dataLoaded"
                        :field_form="'workorders'"
                        :field_list="formInfoList"
                        :form_detail="workOrderDetailsData"
                        :is_edit_mode="false"
                        :pk_id="workOrderDetailsData.id"
                    />
                </div>
            </div>
            <div class="work_order_assign_wrap">
                <div class="page_little_title">
                    <span class="title">工单指派分配</span>
                </div>
                <div>
                    <el-table :data="assignData" size="small" border class="custom_table">
                        <el-table-column label="实施人员" width="140" prop="name">
                            <template slot-scope="{ row }">
                                <PersonnelCard
                                    :userId="row.processing_user.id"
                                    v-if="row.processing_user && row.processing_user.id"
                                >
                                    <template slot="container">
                                        <div class="user-avatar-btn">
                                            <img
                                                :src="
                                                    row.processing_user.avatar ? row.processing_user.avatar : defaultImg
                                                "
                                                alt=""
                                            />
                                            <span>{{ row.processing_user && row.processing_user.name }}</span>
                                        </div>
                                    </template>
                                </PersonnelCard>
                            </template>
                        </el-table-column>
                        <el-table-column label="人员当前状态" width="110" prop="name">
                            <template slot-scope="{ row }">
                                <span class="work_order_status" :class="'work_order_status' + row.status">{{
                                    row.status_text
                                }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="指派时间" min-width="240" prop="name">
                            <template slot-scope="{ row }">
                                <span v-if="row.plan_start_date === row.plan_end_date"
                                    >{{ row.plan_start_date ? formatDate(row.plan_start_date, "date") : "" }}
                                    {{ row.plan_start_time == 1 ? "上午" : "下午" }}-{{
                                        row.plan_end_time == 1 ? "上午" : "下午"
                                    }}</span
                                >
                                <span v-else
                                    >{{ row.plan_start_date ? formatDate(row.plan_start_date, "date") : "" }}
                                    {{ row.plan_start_time == 1 ? "上午" : "下午" }}-{{
                                        row.plan_end_date ? formatDate(row.plan_end_date, "date") : ""
                                    }}
                                    {{ row.plan_end_time == 1 ? "上午" : "下午" }}</span
                                >
                            </template>
                        </el-table-column>

                        <el-table-column label="实际时间" min-width="240" prop="name">
                            <template slot-scope="{ row }">
                                <span v-if="row.start_date || row.end_date">
                                    {{ row.start_date ? formatDate(row.start_date, "date") : "" }}
                                    {{ row.start_time == 1 ? "上午" : "下午" }}-{{
                                        row.end_date
                                            ? `${row.end_date}-${row.end_time == 1 ? "上午" : "下午"}`
                                            : "未完成"
                                    }}
                                </span>
                                <span v-else>未出发</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="分数" min-width="150">
                            <template slot-scope="{ row }">
                                <div class="custom_table_rate" v-if="row.evaluate && row.evaluate.id">
                                    <!-- <el-rate v-model="row.evaluate.star" disabled text-color="#ff9900"> </el-rate> -->
                                    <span>{{ row.evaluate.star }}分</span>
                                    <el-tooltip :content="row.evaluate.content" effect="dark" placement="top">
                                        <span
                                            class="handle_icon_wrap"
                                        >
                                            <i class="iconfont icon-shuoming"></i>
                                        </span>
                                    </el-tooltip>
                                </div>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="work_order_feedback_wrap" v-if="feedBackData.length">
                <div class="page_little_title">
                    <span class="title">工单处理详情</span>
                </div>
                <div class="work_order_feed_back_tab" v-if="feedBackData.length">
                    <el-tabs v-model="feedBackTabActiveId" @tab-click="handleClickTab">
                        <el-tab-pane v-for="user in feedBackData" :label="user.name" :name="user.uid + ''">
                        </el-tab-pane>
                    </el-tabs>
                    <el-table :data="feedBackTabData" size="small" border class="custom_table">
                        <el-table-column label="工作日期" width="110" prop="work_date">
                            <template slot-scope="{ row }">
                                <span>{{ row.work_date ? formatDate(row.work_date, "date") : "--" }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="打卡情况" width="180" prop="clock_id">
                            <template slot-scope="{ row }">
                                <span v-if="row.clock_id" class="link-label">打卡详情</span>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="工作内容" min-width="180" prop="work_content">
                            <template slot-scope="{ row }">
                                <template v-if="row.work_content || (row.files && row.files.length)">
                                    <div style="display: flex; align-items: center">
                                        <el-tooltip  :content="row.work_content" effect="dark" placement="top" v-if="row.work_content">
                                            <span v-if="row.work_content" class="table_desc_txt ellipsis">{{ row.work_content }}</span>
                                        </el-tooltip>
                                        <div
                                            v-if="row.files_image && row.files_image.length"
                                            style="display: flex; align-items: center; justify-content: left"
                                            class="table_img_wrap"
                                        >
                                            <el-image
                                                :preview-src-list="row.files_image.map((file) => file.file_path)"
                                                :src="row.files_image[0].file_path"
                                                title="图片"
                                                alt=""
                                                style="max-width: 32px; max-height: 32px"
                                                v-if="row.files_image && row.files_image.length > 0"
                                            >
                                            </el-image>
                                            <el-popover
                                                placement="bottom-start"
                                                title=""
                                                width="248"
                                                trigger="click"
                                                content=""
                                                popper-class="table_img_popover"
                                            >
                                                <ul class="voucher_list">
                                                    <li
                                                        :key="index"
                                                        class="voucher_item"
                                                        v-for="(item, index) in row.files_image"
                                                    >
                                                        <el-image
                                                            :preview-src-list="
                                                                row.files_image.map((file) => file.file_path)
                                                            "
                                                            :src="item.file_path"
                                                            alt=""
                                                            style="max-width: 32px; max-height: 32px"
                                                        ></el-image>
                                                    </li>
                                                </ul>
                                                <div
                                                    slot="reference"
                                                    class="table_img_mark"
                                                    v-if="row.files_image && row.files_image.length > 1"
                                                >
                                                    <span>{{ row.files_image.length }}</span>
                                                </div>
                                            </el-popover>
                                        </div>
                                        <div v-if="row.files_file && row.files_file.length" class="table_files_wrap">
                                            <el-popover
                                                placement="bottom"
                                                popper-class="id_card_detail_popper"
                                                trigger="click"
                                                width="456"
                                            >
                                                <span slot="reference" class="link-label">
                                                    {{ row.files_file[0].file_name
                                                    }}{{ row.files_file.length > 1 ? row.files_file.length - 1 : "" }}
                                                </span>
                                                <ul class="upload_file_list upload_file_list_detail">
                                                    <li v-for="file in row.files_file" class="upload_file_item">
                                                        <div class="file_left_wrap">
                                                            <img
                                                                alt=""
                                                                class="file_img"
                                                                src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                            />
                                                            <div class="file_info_wrap">
                                                                <p class="file_name" v-text="file.file_name"></p>
                                                                <p class="file_size" v-text="file.file_size"></p>
                                                            </div>
                                                        </div>
                                                        <div class="file_right_wrap">
                                                            <el-tooltip content="预览" effect="dark" placement="top">
                                                                <span
                                                                    class="handle_icon_wrap"
                                                                    @click="handleClickPreview(file)"
                                                                >
                                                                    <i class="iconfont icon-yanjing"></i>
                                                                </span>
                                                            </el-tooltip>
                                                            <span class="line"></span>
                                                            <el-tooltip content="下载" effect="dark" placement="top">
                                                                <span
                                                                    class="handle_icon_wrap"
                                                                    @click="handleClickDownloadFile(file)"
                                                                >
                                                                    <i class="iconfont icon-daochu"></i>
                                                                </span>
                                                            </el-tooltip>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </el-popover>
                                        </div>
                                    </div>
                                </template>
                                <span v-else>暂无每日工作内容</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="work_order_finish_wrap" v-if="finishAllData.length">
                <div class="page_little_title">
                    <span class="title">结单信息</span>
                </div>
                <div class="custom_form_detail_wrap is_detail_form work_order_detail_form" v-if="finishAllData.length">
                    <el-form ref="finishDataForm" :model="finishData" label-position="top" size="small">
                        <el-row :gutter="12">
                            <el-col :span="12" class="flex">
                                <div>
                                    <el-form-item label="结单时间">
                                        <span>{{
                                            finishData && finishData.created_at
                                                ? formatDate(finishData.created_at, "date")
                                                : "--"
                                        }}</span>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="结单人">
                                        <span>{{ finishData && finishData.user && finishData.user.name }} </span>
                                        <!-- <template v-if="assignData.length">
                                            <span v-for="(user,userIndex) in assignData">{{ user.processing_user.name }}{{ userIndex !== assignData.length - 1 ? '、' : '' }}</span>
                                        </template> -->
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工单起止时间">
                                    <span
                                        >{{
                                            (finishData && finishData.start_date
                                                ? formatDate(finishData.start_date, "date")
                                                : "") +
                                            "-" +
                                            (finishData && finishData.end_date
                                                ? formatDate(finishData.end_date, "date")
                                                : "")
                                        }}（共{{ finishData && finishData.duration }}人日）</span
                                    >
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="实施报告/证明">
                                    <div class="file_upload_wrap" v-if="finishData && finishData.files.length">
                                        <ul class="upload_file_list upload_file_list_detail">
                                            <li v-for="file in finishData.files" class="upload_file_item">
                                                <div class="file_left_wrap">
                                                    <img
                                                        alt=""
                                                        class="file_img"
                                                        src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                    />
                                                    <div class="file_info_wrap">
                                                        <p class="file_name" v-text="file.file_name"></p>
                                                        <p class="file_size" v-text="file.file_size"></p>
                                                    </div>
                                                </div>
                                                <div class="file_right_wrap">
                                                    <el-tooltip content="预览" effect="dark" placement="top">
                                                        <span
                                                            class="handle_icon_wrap"
                                                            @click="handleClickPreview(file)"
                                                        >
                                                            <i class="iconfont icon-yanjing"></i>
                                                        </span>
                                                    </el-tooltip>
                                                    <span class="line"></span>
                                                    <el-tooltip content="下载" effect="dark" placement="top">
                                                        <span
                                                            class="handle_icon_wrap"
                                                            @click="handleClickDownloadFile(file)"
                                                        >
                                                            <i class="iconfont icon-daochu"></i>
                                                        </span>
                                                    </el-tooltip>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="结单描述">
                                    <span>{{ finishData && finishData.note }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>
        <WorkOrderAssign
            :dialogVisible.sync="workOrderAssignDialogVisible"
            v-if="workOrderAssignDialogVisible"
            :workorder_id="Number(work_order_id)"
            :processing_users_selected="processing_users_selected"
            @refreshList="getWorkOrderDetail"
        />
        <WorkOrderProcessingUserReplace
            :dialogVisible.sync="processingUserReplaceDialogVisible"
            v-if="processingUserReplaceDialogVisible"
            :workorder_id="Number(work_order_id)"
            :processing_users_selected="processing_users_selected"
            @refreshList="getWorkOrderDetail"
        />
        <WorkOrderProcessingUserRevoke
            :dialogVisible.sync="processingUserRevokeDialogVisible"
            v-if="processingUserRevokeDialogVisible"
            :workorder_id="Number(work_order_id)"
            :processing_users_selected="processing_users_selected"
            @refreshList="getWorkOrderDetail"
        />
        <WorkOrderTravel
            :dialogVisible.sync="workOrderTravelDialogVisible"
            v-if="workOrderTravelDialogVisible"
            :assign_id="assign_id"
            :workorder_id="Number(work_order_id)"
            :workorder_num="workOrderDetailsData.workorder_num"
            :travelInfo="travelInfo"
            @refreshList="getWorkOrderDetail"
        />
        <WorkOrderTransfer
            :dialogVisible.sync="workOrderTransferDialogVisible"
            v-if="workOrderTransferDialogVisible"
            :workorder_id="Number(work_order_id)"
            :processing_users_selected="processing_users_selected"
            @refreshList="getWorkOrderDetail"
        />
        <WorkOrderFeedBack
            :dialogVisible.sync="workOrderFeedBackDialogVisible"
            v-if="workOrderFeedBackDialogVisible"
            :workorder_id="Number(work_order_id)"
            @refreshList="getWorkOrderDetail"
        />
        <WorkOrderFeedBackFinish
            :dialogVisible.sync="workOrderFeedBackFinishDialogVisible"
            v-if="workOrderFeedBackFinishDialogVisible"
            :workorder_id="Number(work_order_id)"
            :workorder_num="workOrderDetailsData.workorder_num"
            :workorder_start_date="workorder_start_date"
            :workorder_start_time="workorder_start_time"
            @refreshList="getWorkOrderDetail"
        />
        <WorkOrderFinish
            :dialogVisible.sync="workOrderFinishDialogVisible"
            v-if="workOrderFinishDialogVisible"
            :workorder_id="Number(work_order_id)"
            :workorder_num="workOrderDetailsData.workorder_num"
            :finishInfo="finishInfo"
            @refreshList="getWorkOrderDetail"
        />
        <WorkOrderEvaluate
            :dialogVisible.sync="workOrderEvaluateDialogVisible"
            v-if="workOrderEvaluateDialogVisible"
            :workorder_id="Number(work_order_id)"
            :workorder_num="workOrderDetailsData.workorder_num"
            :processing_users_selected="processing_users_selected"
            @refreshList="getWorkOrderDetail"
        />
        <el-image
            :preview-src-list="previewImgList"
            :src="previewImgSrc"
            ref="preview_img"
            style="display: none"
        ></el-image>
    </div>
</template>
<script>
import { mapState } from "vuex";
import {
    workOrderSetDetail,
    workOrderDetail,
    workOrderClose,
    workOrderFeedbackStart,
    workOrderFeedbackEnd,
    workOrderRevoke,
} from "@/api";
import { getOSSData } from "@/utils/uploadOss";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import WorkOrderAssign from "./work_order_assign";
import WorkOrderProcessingUserReplace from "./work_order_processing_user_replace";
import WorkOrderProcessingUserRevoke from "./work_order_processing_user_revoke";
import WorkOrderTravel from "./work_order_travel";
import WorkOrderFinish from "./work_order_finish";
import WorkOrderFeedBack from "./work_order_feedback";
import WorkOrderFeedBackFinish from "./work_order_feedback_finish";
import WorkOrderTransfer from "./work_order_transfer";
import WorkOrderEvaluate from "./work_order_evaluate";
import {removeTag} from "@/utils";

export default {
    name: "WorkOrderDetail",
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            work_order_id: this.$route.query.work_order_id && Number(this.$route.query.work_order_id),
            workOrderDetailsData: {},
            formInfoList: [],
            assignData: [],
            feedBackTabActiveId: "",
            feedBackTabData: [], // 当前工单处理详情tab的数据
            feedBackData: [], // 所有的工单处理详情数据，按照姓名分组
            finishAllData: [],
            finishData: {},
            statusData: {
                0: "审批中",
                1: "待指派",
                2: "待出发",
                3: "待实施",
                4: "实施中",
                5: "实施完成",
                6: "已结单",
                7: "已评价",
                "-1": "已拒绝",
                "-2": "已撤销",
                "-3": "已关闭",
            },
            // 获取工单后台配置
            workOrderSetForm: {},
            // 操作
            isMoreOperateBtn: true,
            moreOperateType: "",
            isCurrentProcessingUserStatus: null, // 判断当前实施人的状态

            workOrderAssignDialogVisible: false,
            processingUserReplaceDialogVisible: false,
            processingUserRevokeDialogVisible: false,
            workOrderTransferDialogVisible: false,
            workOrderTravelDialogVisible: false,
            workOrderFeedBackDialogVisible: false,
            workOrderFeedBackFinishDialogVisible: false,
            workOrderFinishDialogVisible: false,
            workOrderEvaluateDialogVisible: false,
            processing_users_selected: [],
            assign_id: 0,
            processing_uid: "",
            old_processing_uid: 0,
            travelInfo: {},
            finishInfo: {},
            workorder_start_date: "", // 每个实施人员的开始时间
            workorder_start_time: "",

            previewImgList: [],
            previewImgSrc: "",
        };
    },
    components: {
        CustomFormDetailPc,
        PersonnelCard,
        WorkOrderAssign,
        WorkOrderProcessingUserReplace,
        WorkOrderProcessingUserRevoke,
        WorkOrderTravel,
        WorkOrderTransfer,
        WorkOrderFeedBack,
        WorkOrderFeedBackFinish,
        WorkOrderFinish,
        WorkOrderEvaluate,
    },
    created() {
        this.getWorkOrderSetDetail();
        this.getWorkOrderDetail();
    },
    mounted() {},
    computed: {
        ...mapState(["userInfo"]),
        owner_uid() {
            return this.userInfo && this.userInfo.user && this.userInfo.user.id;
        },
    },
    methods: {
        handleClickReturn() {
            removeTag(this.$route)
            // this.$router.go(-1);
            this.$router.push({
                name: "WorkOrder"
            })
        },
        // 获取工单后台配置
        getWorkOrderSetDetail() {
            workOrderSetDetail().then((res) => {
                this.workOrderSetForm = res.data || {};
            });
        },
        // 获取订单详情
        getWorkOrderDetail() {
            this.loading = true;
            this.dataLoaded = false;
            workOrderDetail({
                id: this.work_order_id,
            }).then((res) => {
                if (res.code === 200) {
                    const { workorder, finish, assign, feedback, custom_fields } = res.data;
                    this.workOrderDetailsData = workorder;
                    this.formInfoList = custom_fields;
                    this.dataLoaded = true;

                    // 判断是否有更多操作，并且给下拉框默认显示第一个选项
                    const status = this.workOrderDetailsData.status; // 当前工单状态
                    // 获取当前实施人的状态
                    const isCurrentProcessingUserStatus = this.workOrderDetailsData.processing_status;
                    this.isCurrentProcessingUserStatus = isCurrentProcessingUserStatus;
                    if (
                        status == 2 ||
                        status == 3 ||
                        status == 4 ||
                        isCurrentProcessingUserStatus === 0 ||
                        isCurrentProcessingUserStatus === 1 ||
                        isCurrentProcessingUserStatus === 2
                    ) {
                        const is_assign_user = this.workOrderDetailsData.is_assign_user;
                        const assign_uids = this.workOrderDetailsData.assign_uids;
                        const is_owner_uid = this.workOrderDetailsData.uid === this.owner_uid;
                        const is_has_assign_user = (assign_uids.length && assign_uids.includes(this.owner_uid)) || (!assign_uids.length && is_assign_user)
                        this.workOrderDetailsData.is_has_assign_user = is_has_assign_user
                        if (
                            status == 2 ||
                            status == 3 ||
                            isCurrentProcessingUserStatus === 0 ||
                            isCurrentProcessingUserStatus === 1
                        ) {
                            const isTransferWorkOrder =
                                (isCurrentProcessingUserStatus === 0 || isCurrentProcessingUserStatus === 1) &&
                                this.workOrderSetForm &&
                                this.workOrderSetForm.is_transfer === 1 &&
                                this.workOrderDetailsData.is_processing_user;
                            if (isTransferWorkOrder) {
                                this.moreOperateType = "transferWorkOrder";
                            } else if ((assign_uids.length && assign_uids.includes(this.owner_uid)) || (!assign_uids.length && is_assign_user)) {
                                this.moreOperateType = "replaceWorkOrder";
                            } else if (is_owner_uid) {
                                this.moreOperateType = "closeWorkOrder";
                            } else {
                                this.moreOperateType = "";
                                this.isMoreOperateBtn = false;
                            }
                        } else {
                            if ((assign_uids.length && assign_uids.includes(this.owner_uid)) || (!assign_uids.length && is_assign_user)) {
                                this.moreOperateType = "distributeWorkOrder";
                            } else if (is_owner_uid) {
                                this.moreOperateType = "closeWorkOrder";
                            } else {
                                this.moreOperateType = "";
                                this.isMoreOperateBtn = false;
                            }
                        }
                    } else {
                        this.isMoreOperateBtn = false;
                    }

                    this.assignData = assign;
                    // 将数据按照人员姓名进行分组
                    const userData = this.groupUserData(feedback);
                    let feedBackData = [];
                    for (let key in userData) {
                        const userItemData = userData[key].map((item) => {
                            return {
                                ...item,
                                files_image: item.files.length
                                    ? item.files.filter((file) => !file.file_type && !file.file_size)
                                    : [],
                                files_file: item.files.length
                                    ? item.files.filter((file) => file.file_size || file.file_type)
                                    : [],
                            };
                        });
                        feedBackData.push({
                            id: key + "",
                            uid: userData[key][0].uid,
                            name: userData[key][0]?.user?.name,
                            data: userItemData,
                        });
                    }
                    this.feedBackData = feedBackData || [];
                    this.feedBackTabData = this.feedBackData.length ? this.feedBackData[0].data : [];
                    this.feedBackTabActiveId =
                        this.feedBackTabData && this.feedBackTabData.length ? this.feedBackTabData[0].uid + "" : "";
                    this.finishAllData = finish || [];
                    this.finishData = finish ? finish[0] : {};

                    this.loading = false;
                } else {
                    this.$message.error(res.message);
                    this.loading = false;
                }
            });
        },
        formatDate(dateString, date_type) {
            // 创建日期对象
            const dateObj = new Date(dateString);
            // 获取年、月、日
            const year = dateObj.getFullYear();
            const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
            const day = ("0" + dateObj.getDate()).slice(-2);
            const hours = ("0" + dateObj.getHours()).slice(-2);
            const minutes = ("0" + dateObj.getMinutes()).slice(-2);
            const seconds = ("0" + dateObj.getSeconds()).slice(-2);
            let formattedDateTime = "";
            if (date_type === "date") {
                formattedDateTime = year + "/" + month + "/" + day;
            } else if (date_type === "year-month") {
                formattedDateTime = year + "/" + month;
            } else if (date_type === "datetime") {
                formattedDateTime = year + "/" + month + "/" + day + " " + hours + ":" + minutes;
            } else if (date_type === "hourtime") {
                formattedDateTime = hours + ":" + minutes + ":" + seconds;
            } else if (date_type === "month") {
                formattedDateTime = month + "/" + day;
            } else if (date_type === "date-second-time") {
                formattedDateTime = year + "/" + month + "/" + day + " " + hours + ":" + minutes + ":" + seconds;
            }
            return formattedDateTime;
        },
        groupUserData(data) {
            const grouped = data.reduce((result, item) => {
                const key = item.uid; // 分组依据的属性
                if (!result[key]) {
                    result[key] = []; // 初始化该类型的数组
                }
                result[key].push(item); // 将元素加入对应分组
                return result;
            }, {}); // 初始值为空对象
            return grouped;
        },
        handleClickTab(tab) {
            const index = Number(tab.index || 0);
            this.feedBackTabData = this.feedBackData[index]?.data || [];
        },
        // 更多操作
        handleMoreOpetateTypeChange(type) {
            this.moreOperateType = type;
            switch (type) {
                case "transferWorkOrder":
                    this.handleClickTransferWorkOrder();
                    break;
                case "distributeWorkOrder":
                    this.handleClickDistributeWorkOrder();
                    break;
                case "replaceWorkOrder":
                    this.handleClickReplaceWorkOrder();
                    break;
                case "revokeDistributeWorkOrder":
                    this.handleClickRevokeDistributeWorkOrder();
                    break;
                case "closeWorkOrder":
                    this.handleClickCloseWorkOrder();
                    break;
                default:
                    break;
            }
        },
        //编辑工单
        handleClickEditWorkOrder() {
            this.$router.push({
                name: "WorkOrderEdit",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: this.work_order_id,
                    name: this.workOrderDetailsData.workorder_num,
                },
            });
        },
        //撤销工单
        handleClickRevokeWorkOrder() {
            this.$msgbox({
                title: "撤销",
                message: "确定要撤销所选工单吗？",
                confirmButtonText: "撤销",
                cancelButtonText: "取消",
                confirmButtonClass: "el-button--primary",
                iconClass: "iconfont icon-shuoming",
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                showClose: false,
            })
                .then(() => {
                    workOrderRevoke({
                        workorder_id: this.work_order_id,
                        approval_id: this.workOrderDetailsData.approval_id,
                    }).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getWorkOrderDetail();
                        }
                    });
                })
                .catch(() => {});
        },
        //删除工单
        handleClickDelWorkOrder() {
            this.$msgbox({
                title: "删除",
                message: "确定要删除所选工单吗？",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                iconClass: "iconfont icon-yiwen",
                customClass: "icon_title_message_box icon_title_message_box_danger",
                confirmButtonClass: "el-button--danger",
                showClose: false,
            })
                .then(() => {
                    workOrderDel({ id: this.work_order_id }).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.$router.go(-1);
                        }
                    });
                })
                .catch(() => {
                    console.log("cancel");
                });
        },
        //分配实施人员
        handleClickDistributeWorkOrder() {
            this.processing_users_selected = (this.assignData || []).filter(user=> user.status !== 3);
            this.workOrderAssignDialogVisible = true;
        },
        //替换实施人员
        handleClickReplaceWorkOrder() {
            this.processing_users_selected = this.assignData || [];
            this.processingUserReplaceDialogVisible = true;
        },

        //撤回实施人员
        handleClickRevokeDistributeWorkOrder(row) {
            this.processing_users_selected = this.assignData || [];
            this.processingUserRevokeDialogVisible = true;
        },
        //工单出发
        handleClickStartWorkOrder() {
            if(this.workOrderDetailsData.processing_approval_id && this.workOrderDetailsData.processing_approval_status === 0) return this.$message.error("您已发起工单出发申请，请等待审批通过!")
            this.assign_id = this.workOrderDetailsData.assign_id || 0;
            this.travelInfo = {
                project_id: this.workOrderDetailsData.project_id.value,
                project_name: this.workOrderDetailsData.project_id.text,
                order_id: this.workOrderDetailsData.order_id.value,
                order_num: this.workOrderDetailsData.order_id.text,
            };
            this.workOrderTravelDialogVisible = true;
        },
        //工单实施开始
        handleClickWorkOrderImplementStart() {
            this.$msgbox({
                title: "实施开始",
                message: "确定现在已到达现场并开始实施吗？",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                confirmButtonClass: "el-button--primary",
                iconClass: "iconfont icon-shuoming",
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                showClose: false,
            })
                .then(() => {
                    const params = { workorder_id: this.work_order_id , workorder_num: this.workOrderDetailsData.workorder_num, processing_uid: this.owner_uid, processing_name: this.userInfo && this.userInfo.user && this.userInfo.user.name}
                    workOrderFeedbackStart(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getWorkOrderDetail();
                        }
                    });
                })
                .catch(() => {});
        },
        //工单转单
        handleClickTransferWorkOrder() {
            this.processing_users_selected = this.workOrderDetailsData.processing_users || [];
            this.workOrderTransferDialogVisible = true;
        },
        //工单每日工作填写
        handleClickWorkOrderDailyWork() {
            this.workOrderFeedBackDialogVisible = true;
        },
        //工单实施结束
        handleClickWorkOrderImplementEnd() {
            // 1=极简模式,2=简约工程模式
            const mode = this.workOrderDetailsData.mode;
            if (mode === 1) {
                this.$msgbox({
                    title: "实施结束",
                    message: "确定现在已完成实施了吗？",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    confirmButtonClass: "el-button--primary",
                    iconClass: "iconfont icon-shuoming",
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                    customClass: "prompt_message_custom",
                    showClose: false,
                })
                    .then(() => {
                        workOrderFeedbackEnd({
                            workorder_id: this.work_order_id,
                            workorder_num: this.workOrderDetailsData.workorder_num,
                        }).then((res) => {
                            if (res.code === 200) {
                                this.$message.success(res.message);
                                this.getWorkOrderDetail();
                            }
                        });
                    })
                    .catch(() => {});
            } else {
                const currentUser = this.assignData.filter(user=> user.processing_uid === this.owner_uid && user.status !== 3)[0]
                this.workorder_start_date = currentUser.start_date;
                this.workorder_start_time = currentUser.start_time;
                this.workOrderFeedBackFinishDialogVisible = true;
            }
        },
        // 工单结单
        handleClickEndWorkOrder() {
            const isAllFinish = this.assignData.every((user) => user.status === 3);
            if (isAllFinish) {
                this.finishInfo = {
                    project_id: this.workOrderDetailsData.project_id.value,
                    project_name: this.workOrderDetailsData.project_id.text,
                    order_id: this.workOrderDetailsData.order_id.value,
                    order_num: this.workOrderDetailsData.order_id.text,
                };
                this.workOrderFinishDialogVisible = true;
            } else {
                this.$message.error("全部实施人实施完成后才可以结单");
            }
        },
        //关闭工单
        handleClickCloseWorkOrder() {
            this.$msgbox({
                title: "关闭工单",
                message: "确定要关闭所选工单吗？",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                confirmButtonClass: "el-button--primary",
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                showClose: false,
            })
                .then(() => {
                    workOrderClose({
                        workorder_id: this.work_order_id,
                        workorder_num: this.workOrderDetailsData.workorder_num,
                    }).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getWorkOrderDetail();
                        }
                    });
                })
                .catch(() => {
                    console.log("cancel");
                });
        },
        //再次发起工单
        handleClickRestartWorkOrder() {
            this.$router.push({
                name: "WorkOrderAddAgain",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: this.work_order_id,
                },
            });
        },
        //工单评价
        handleClickEvaluateWorkOrder() {
            this.processing_users_selected = this.assignData || [];
            this.workOrderEvaluateDialogVisible = true;
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件类型不支持预览");
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
    },
};
</script>
<style lang="scss" scoped>
.page_header {
    .work_order_header_flex {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        gap: 16px;
    }
}
.page_body {
    padding: 4px;
    overflow-y: auto;
    background-color: #edf0f4;

    & > div {
        padding: 16px;
        background-color: #ffffff;
        border-radius: 6px;
        margin-bottom: 4px;
    }
    .work_order_info_wrap {
    }

    .work_order_status {
        position: relative;
        padding-left: 10px;

        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -3px;
            width: 6px;
            height: 6px;
            opacity: 1;
            border-radius: 50%;
        }

        &.work_order_status0,
        &.work_order_status1,
        &.work_order_status2,
        &.work_order_status3,
        &.work_order_status4 {
            &::before {
                background-color: rgba(240, 170, 50, 1);
            }
        }

        &.work_order_status-1 {
            &::before {
                background-color: rgba(228, 65, 68, 1);
            }
        }

        &.work_order_status-2,
        &.work_order_status-3,
        &.work_order_status7 {
            &::before {
                background-color: rgba(191, 191, 191, 1);
            }
        }

        &.work_order_status5,
        &.work_order_status6 {
            &::before {
                background-color: rgba(90, 179, 51, 1);
            }
        }
    }

    .work_order_detail_form {
        .flex {
            & > div {
                flex: 1;
            }
        }
    }

    .work_order_feedback_wrap {
        .page_little_title {
            margin-bottom: 8px;
        }
    }

    .work_order_feed_back_tab {
        .el_tabs {
            .el-tabs__header {
                ::v-deep {
                    .el-tabs__item {
                        height: 34px;
                        line-height: 34px;
                    }
                }
            }
        }
    }

    .work_order_finish_wrap {
        .custom_form_detail_wrap {
            .file_upload_wrap {
                height: auto;
            }

            .upload_file_list {
                display: flex;
                flex-wrap: wrap;
                gap: 16px;

                .upload_file_item {
                    width: calc(50% - 8px);
                    margin-bottom: 0;
                }
            }
        }
    }
}
.table_desc_txt {
    max-width: 364px;
}
.table_img_wrap {
    flex-shrink: 0;
    display: inline-block;
    vertical-align: middle;
    margin-left: 8px;
    margin-right: 8px;
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 4px;

    .table_img_mark {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 32px;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.6);
        cursor: pointer;

        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(255, 255, 255, 1);
        }
    }
}
.table_files_wrap {
    flex-shrink: 0;
}
.table_img_popover {
    padding: 8px;

    .voucher_list {
        display: flex;
        gap: 8px;

        .voucher_item {
            width: 32px;
            height: 32px;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 32px;
            border-radius: 4px;

            .el-image {
                max-width: 100%;
                max-height: 100%;
            }

            img {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }
        }
    }
}
.el-table {
    ::v-deep {
        td.el-table__cell .cell {
            font-size: 14px;
        }
    }
}
.custom_table_rate {
    display: flex;
    align-items: center;
    line-height: 22px;
    gap: 4px;
    & > span {
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
    }
    .handle_icon_wrap {
        i {
            color: rgba(240, 170, 50, 1);
        }
    }
}
</style>
